






































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import columns from "./sale-order-columns";
import opsColumns from "./ops-sale-order-columns";
import clientColumns from "./client-sale-order-columns";
import Customer from "@/store/entities/customers/customer";
import Client from "../../../store/entities/client";
import _ from "lodash";
import moment from "moment";

class PageSaleOrderRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  status: string;
  warehouseCode: string;
  from: Date;
  to: Date;
  customerId: number;
  outboundMode: string;
  productKeyword: string;
}

@Component
export default class SaleOrder extends mixins(ListMixin, AbpBase) {
  namespace = "saleOrder";
  pagerequest: PageSaleOrderRequest = new PageSaleOrderRequest();
  spinShow: boolean = false;
  creationTime: Date[] = [];

  customerLoading: boolean = false;
  customers: Array<Customer> = new Array<Customer>();
  customer: Customer = new Customer();
  clients: Array<Client> = new Array<Client>();
  statuses = [];
  warehouses = [];
  outboundModes = [];

  get store() {
    return this.$store.state.saleOrder;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  async getStatuses() {
    await this.$store
      .dispatch({
        type: "saleOrder/getSoStatusesForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.saleOrder.soStatuses;
        this.pagerequest.status = re.length === 0 ? "" : re[0].code;
        this.statuses = re;
      });
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        if (!this.isTenant())
          this.pagerequest.warehouseCode = re.length === 0 ? "" : re[0].id;
        this.warehouses = re;
      });
  }
  async getOutboundModes() {
    await this.$store
      .dispatch({
        type: "saleOrder/getOutboundModesForSelect",
        data: { hasAllItem: true },
      })
      .then((result) => {
        this.outboundModes = result;
        this.pagerequest.outboundMode =
          this.outboundModes.length > 0 ? this.outboundModes[0].code : "";
      });
  }
  viewSo(id: string) {
    this.$root.$router.push({ name: "saleorder/:id", params: { id: id } });
  }

  get list() {
    var re = this.$store.state.saleOrder.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    this.pagerequest.from = null;
    this.pagerequest.to = null;
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.tenant.tenancyName;
    }
    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.from = moment(this.creationTime[0])
        .startOf("d")
        .toDate();
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.to = moment(this.creationTime[1])
        .endOf("d")
        .toDate();
    }
  }
  renderColumn() {
    if (this.isClient()) {
      return clientColumns.concat(columns);
    }
    if (this.isTenant()) {
      return opsColumns.concat(columns);
    }
    return opsColumns.concat(clientColumns).concat(columns);
  }
  get columns() {
    return [
      {
        title: Util.L("Order"),
        key: "orderNo",
        width: 50,
      },
      ...this.renderColumn(),
      {
        title: Util.L("Action"),
        width: 120,
        fixed: "right",
        slot: "action",
        align: "center",
      },
    ];
  }
  async created() {
    this.refreshListData();
    this.spinShow = true;
    try {
      await this.getClients();
      await this.getStatuses();
      await this.getWarehouses();
      await this.getOutboundModes();

      var defaultDate = new Date();
      var defaultDateFrom = moment()
        .add(-7, "d")
        .toDate();
      this.creationTime = [defaultDateFrom, defaultDate];
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
        if (!this.isClient())
          this.pagerequest.clientCode =
            this.clients.length === 0 ? "" : this.clients[0].code;
      });
  }

  searchCustomer_OnPress = _.debounce(
    this.searchCustomers,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );

  async searchCustomers(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.customerLoading = true;
    this.customers = await this.$store.dispatch({
      type: "customer/searchCustomerForSelect",
      data: {
        keyWord: keyword,
      },
    });
    this.customerLoading = false;
  }

  onChangeClient() {
    this.customers = [];
  }
}
